import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import ShmupCard from "../components/ShmupCard";
import { loadShmupsActionCreator } from "../redux/features/shmupsSlice";
import ShmupListPageStyled from "./ShmupListPageStyled";

const ShmupListPage = () => {
  const shmups = useSelector((state) => state.shmups);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadShmupsActionCreator);
  }, [dispatch]);

  return (
    <>
      <Header />
      <ShmupListPageStyled>
        {shmups.map((shmup) => {
          return <ShmupCard key={shmup.id} shmup={shmup} />;
        })}
      </ShmupListPageStyled>
    </>
  );
};

export default ShmupListPage;
